module.exports = __webpack_public_path__ + "static/fonts/Roboto Slab Regular.b2998202.ttf";